import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SDKProvider } from './context/SDKContext.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import RequireAuth from './components/auth/RequireAuth.tsx';
import RequireRole from './components/auth/RequireRole.tsx';
import { ADMIN_ROLES } from './context/AuthContext.tsx';
import AdminLayout from './components/layout/AdminLayout.tsx';
import LoginPage from './pages/LoginPage.tsx';
import ChatPage from './pages/ChatPage.tsx';

// Pages admin (S5.4-11 à S5.5-02)
import DashboardPage from './pages/DashboardPage.tsx';
import UsersPage from './pages/UsersPage.tsx';
import PremiumPage from './pages/PremiumPage.tsx';
import FinopsPage from './pages/FinopsPage.tsx';
import EnvDoctorPage from './pages/EnvDoctorPage.tsx';
import GovernancePage from './pages/GovernancePage.tsx';
import ClauseBenefPage from './pages/ClauseBenefPage.tsx';
import HitlPage from './pages/HitlPage.tsx';
import LicencesPage from './pages/Licences.tsx';
import AiActRegisterPage from './pages/AiActRegisterPage.tsx';
import AuditPage from './pages/AuditPage.tsx';

import { Scroll } from 'lucide-react';

const DossiersPlaceholder = () => (
  <div className="flex flex-col items-center justify-center h-64 text-muted-foreground text-sm space-y-2">
    <Scroll size={32} className="text-muted-foreground/60 animate-pulse" />
    <span className="font-semibold text-foreground text-base">Dossiers Actifs &amp; Observabilité</span>
    <span>Cockpit de supervision des dossiers en cours de traitement (Jalon OPS-04)</span>
  </div>
);

export default function AppConsole(): React.ReactElement {
  return (
    <SDKProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              path="/"
              element={
                <RequireAuth>
                  <Navigate to="/dashboard" replace />
                </RequireAuth>
              }
            />

            {/* Expérience RAG & chat restants pour compatibilité d'administration */}
            <Route
              path="/rag"
              element={
                <RequireAuth>
                  <ChatPage />
                </RequireAuth>
              }
            />
            <Route 
              path="/chat" 
              element={
                <RequireAuth>
                  <ChatPage />
                </RequireAuth>
              } 
            />

            <Route
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route path="dashboard"  element={<DashboardPage />} />
              <Route path="audit"      element={<RequireRole allow={['auditor', 'admin', 'root']}><AuditPage /></RequireRole>} />
              <Route path="users"      element={<RequireRole allow={ADMIN_ROLES}><UsersPage /></RequireRole>} />
              <Route path="premium"    element={<RequireRole allow={ADMIN_ROLES}><PremiumPage /></RequireRole>} />
              <Route path="licenses"   element={<RequireRole allow={ADMIN_ROLES}><LicencesPage /></RequireRole>} />
              <Route path="finops"     element={<RequireRole allow={ADMIN_ROLES}><FinopsPage /></RequireRole>} />
              <Route path="env-doctor"  element={<RequireRole allow={ADMIN_ROLES}><EnvDoctorPage /></RequireRole>} />
              <Route path="governance" element={<RequireRole allow={ADMIN_ROLES}><GovernancePage /></RequireRole>} />
              <Route path="ai-act"     element={<RequireRole allow={ADMIN_ROLES}><AiActRegisterPage /></RequireRole>} />
              <Route path="clausebenef" element={<ClauseBenefPage />} />
              <Route path="dossiers"   element={<DossiersPlaceholder />} />
              <Route path="hitl"       element={<HitlPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SDKProvider>
  );
}
